import PageComponent from '../base/PageComponent';
import SearchAjaxTable from './SearchAjaxTable';
import SearchTab from './SearchTab';

/**
 * Creates an search form linked to the an SearchAjaxTable to display results.
 */
export default class SearchForm extends PageComponent
{
    /**
     * Initialise
     */
    init() {
        let table = this.getTable();

        // determine mode, if we are on the search page, perform an ajax request,
        // else redirect to the search page
        this.mode = table.length ? 'ajax' : 'redirect';

        if (this.mode === 'ajax') {
            // Set up the Search Result table
            this.table = new SearchAjaxTable(
                table,
                {q: this.getSearchTerm()},
                ['q', 'filters[Status]']
            );
            this.table.init();

            // how search form by default
            this.element.addClass('open');
        }

        this.tabs = $('.search-tab').map((i, el) => {
            const t = new SearchTab(el);
            t.init();
            t.setSearchTerm(this.getSearchTerm())
            return t;
        })

        // Wire the form submit handler
        this.element.on('submit', 'form', (e) => this.submit(e));
    }

    /**
     * Handle form submission to push a state update into the result table.
     * @param  Event e
     * @return void
     */
    submit(e) {
        if (this.mode === 'ajax') {
            e.preventDefault();
            this.table.setState({
                q: this.getSearchTerm(),
                "filters[Status]": this.getStatusFilter(),
                page: 1
            })
        }
        this.tabs.map((i, e) => {
            e.setSearchTerm(this.getSearchTerm())
        })
    }

    /**
     * Gets the table element for results.
     *
     * @returns {*|jQuery|HTMLElement}
     */
    getTable() {
        return $(this.element.data('ajax-table'));
    }

    /**
     * Adds the type and query to the form action to generate the search url.
     *
     * @returns {string}
     */
    getSubmitURL() {
        let url = this.childElements('form').attr('action');
        url += '/' + this.childElements('[name=type]').val() + '?q=' + this.getSearchTerm();
        return url;
    }

    /**
     * Get the value of the search term from the input field.
     * @return string
     */
    getSearchTerm() {
        return this.childElements('[name="q"]').val();
    }

    /**
     * Get the value of the status filter from the input field.
     * @return string
     */
    getStatusFilter() {
        const statusFilter = this.childElements('[name="filters[Status]"]');
        return statusFilter.length > 0 ? statusFilter.val() : undefined;
    }

}
